// import { AxiosError } from 'axios';
import { selfServiceApiClient } from 'config/selfServiceApi';

export const getSavedGroupTags = (groupNames = []) => {
  return selfServiceApiClient.post('/api/self-service/tags/group', groupNames);
};

export const getFormatGroupTags = (groupNames = []) => {
  return selfServiceApiClient.post('/api/self-service/tags/formattags', groupNames);
};

export const getBrands = () => {
  return selfServiceApiClient('/api/self-service/brands');
};

export const getLatestBookingsAndQuotes = (paramsValue = '') => {
  const queryParams = paramsValue ? `?${paramsValue}` : '';
  return selfServiceApiClient(`/api/self-service/composite/qb${queryParams}`);
};

export const getUsersNames = (userIds = []) => {
  return selfServiceApiClient.post('/api/self-service/users/names', userIds);
};

export const getDocumentTypes = (bookingRef) => {
  return selfServiceApiClient(`/api/self-service/documentTypes?reference=${bookingRef}`);
};

export const getDocumentUrl = (document, bookingRef) => {
  const typeParam = `type=${document.name} ${document.number}`;
  const paymentIdParam = document.paymentId ? `&paymentId=${document.paymentId}` : '';
  const bookingRefParam = bookingRef ? `&reference=${bookingRef}` : '';
  const fileNameParam = document.fileName ? `&fileName=${document.fileName}` : '';
  return `/api/self-service/document?${typeParam}${paymentIdParam}${bookingRefParam}${fileNameParam}`;
};

export const getPaymentDetails = (bookingRef, cardType = null) => {
  let url = `/api/self-service/paymentDetails?bookingReference=${bookingRef}`;
  if (cardType) {
    url += `&cardType=${cardType}`;
  }
  return selfServiceApiClient(url);
};

export const getPaymentHistory = (bookingRef) => {
  return selfServiceApiClient(
    `/api/self-service/paymentRecords/${bookingRef}`,
  );
};

export const getCanvasQuoteDocuments = () => {
  return selfServiceApiClient('/api/self-service/canvasdocs');
};
